import { Dimensions, Platform, StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  label: {
    marginHorizontal: 16,
    marginTop: 16,
    marginBottom: -1,
    paddingHorizontal: 16,
    paddingTop: 6,
    paddingBottom: 7,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    alignSelf: 'flex-start',
    backgroundColor: Colors.ocean,
  },
  card: (withLabel) => ({
    borderTopLeftRadius: withLabel ? 0 : 6,
    marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 16,
    marginRight: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 20 : null,
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 20 : 16,
    borderColor: Colors.ocean,
    borderWidth: withLabel ? 1 : 0,
  }),
})

export default styles
